module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('div', {
    staticClass: "info"
  }, [_c('h2', [_vm._v(_vm._s(_vm.news.title))]), _vm._v(" "), _c('div', {
    staticClass: "credits"
  }, [(_vm.news.date) ? _c('span', [_vm._v(_vm._s(_vm.$d(new Date(_vm.news.date), 'short')))]) : _vm._e(), _vm._v(" - "), _c('span', [_vm._v(_vm._s(_vm.news.author))])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.news.content)
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c32df0a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/News.vue
// module id = 281
// module chunks = 0